export const formatAmount = (
  value: number | string,
  currency = "AED",
  skipCurrency = false
) => {
  let numValue =
    typeof value === "string"
      ? parseFloat(value?.replace(/[^0-9.-]+/g, ""))
      : value;

  // Format the number to two decimal places with comma separators
  let formattedValue = numValue?.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return skipCurrency ? formattedValue : `${currency} ${formattedValue}`;
};
